import React from 'react';

function Footer() {
  return (
    <footer className="footer">
      <h1></h1>
    </footer>
  );
}

export default Footer;